import React from 'react';
import { SubdomainTest } from '../components/SubdomainTest';

const SubdomainTestPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SubdomainTest />
    </div>
  );
};

export default SubdomainTestPage;
